import React from 'react';

const PHASE_LABELS = {
  tutorial: 'Tutorial',
  frontloading: 'Introduction',
  learning: 'I Do — Learning',
  workbook_ready: 'We Do — Workbook',
  workbook_exercise: 'We Do — Workbook',
  workbook_options: 'We Do — Review',
  knowledge_check: 'You Do — Check',
  knowledge_check_summary: 'Check Summary',
  mastery: 'Mastery Test',
  results: 'Results',
};

const LCVTutorPanel = ({text, phase}) => {
  if (!text) return null;

  return (
    <div className="lcv-tutor-panel">
      <div className="lcv-tutor-header">
        <div className="lcv-tutor-avatar">🎩</div>
        <span className="lcv-tutor-name">Benjamin Franklin</span>
        <span className="lcv-tutor-phase-label">{PHASE_LABELS[phase] || ''}</span>
      </div>
      <div className="lcv-tutor-text">{text}</div>
    </div>
  );
};

export default LCVTutorPanel;
